import { defineMessages } from 'react-intl';

export default defineMessages({
  totalBorrowed: { defaultMessage: 'Total Borrowed' },
  availableLiquidity: { defaultMessage: 'Available Liquidity' },
  utilisationRate: { defaultMessage: 'Utilisation rate' },
});
